import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { CommonDBCityClient, CommonDBCountryClient, CommonDBRegionClient, PotentialStoreLocationClient, MallMetadataClient } from "./generated-pipe-api";

@NgModule({
    imports: [
        HttpModule
    ],
    providers: [
        CommonDBCountryClient,
        CommonDBRegionClient,
        CommonDBCityClient,
        PotentialStoreLocationClient,
        MallMetadataClient
    ]
})
export class GeneratedServicesModule {
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_generated/generated-services-module.ts